exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".action{width:5px}th.active .arrow{opacity:1}.arrow{display:inline-block;vertical-align:middle;width:0;height:0;margin-left:5px;opacity:.66}.arrow.asc{border-bottom:4px solid #2c3e50}.arrow.asc,.arrow.dsc{border-left:4px solid transparent;border-right:4px solid transparent}.arrow.dsc{border-top:4px solid #2c3e50}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-291730e4!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Banet/components/BanetTablegrid.vue
// module id = 584
// module chunks = 0